<template>
  <div class="class-table">
    <div class="class-header">
      <div class="header-left">
        <div>{{$t('jobManagementV2.completion')}}：<span
                class="num"><span>{{classOperation.finishCount}}</span>/{{classOperation.totalNum}}</span>
        </div>
        <div>{{$t('homeworkManage.averageScores')}}：<span
                class="score">{{classOperation.averageScore}}</span></div>
      </div>
      <div class="header-right">
        <el-button type="primary" size="small" @click="handleClassExport">
          {{$t('jobManagementV2.downloadReport')}}</el-button>
        <el-input size="small" @clear="searchNameClear" clearable
                  v-model.trim="query.filter.userName" @keyup.enter.native="handleNameSearch"
                  :placeholder="$t('managementV2.searchStudents')">
          <el-button slot="append" icon="el-icon-search" size="small" @click="handleNameSearch">
          </el-button>
        </el-input>
      </div>
    </div>
    <div class="table-content">
      <el-table height="100%" :data="taskList" border header-row-class-name="customHeader">
        <el-table-column align="center" :label="$t('projectV2.index')" type="index" width="60"
                         :resizable="false"></el-table-column>
        <el-table-column show-overflow-tooltip align="center"
                         :label="$t('managementV2.studentName')" prop="name" :resizable="false">
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center"
                         :label="$t('warehousingAudit.submissionTime')" :resizable="false">
          <template slot-scope="{ row }">{{row.finishTime || '--'}}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center"
                         :label="$t('homeworkManage.jobStatus')" :resizable="false">
          <template slot-scope="{ row }">
            <span
                  :class="`task-status status-${statusFormat(row, 1)}`">{{statusFormat(row, 2)}}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" :label="$t('homeworkManage.score')"
                         prop="manualScore" :resizable="false">
          <template slot-scope="{ row }">{{scoreFormat(row)}}</template>
        </el-table-column>
        <el-table-column class-name="operate" show-overflow-tooltip align="center"
                         :label="$t('newProjectV2.action')" :resizable="false">
          <template slot-scope="{ row }">
            <el-tooltip effect="dark" :content="$t('projectV2.details')" placement="top">
              <i class="icon-view" @click="handleDetail(row, 'view')"></i>
            </el-tooltip>
            <el-tooltip effect="dark" :content="$t('common.download')" placement="top"
                        v-if="[1, 4].includes(statusFormat(row, 1))">
              <el-popover :ref="`popover-${row.id}`" @after-leave="downloadHide" trigger="click"
                          placement="bottom" popper-class="homework-download"
                          :visible-arrow="false">
                <el-cascader-panel v-model="downloadStr" :props='props' :options="options"
                                   @change='downloadReport($event, row)'></el-cascader-panel>
                <i class="icon-download" slot="reference"></i>
              </el-popover>
            </el-tooltip>
            <el-tooltip effect="dark" :content="$t('jobManagementV2.downloadReport')"
                        placement="top">
              <i class="icon-report" @click="handleSingleExport(row)"
                 v-if="[1, 4].includes(statusFormat(row, 1))"></i>
            </el-tooltip>
            <el-tooltip effect="dark" :content="$t('homeworkManage.evaluation')" placement="top">
              <i :class="`icon-star icon-star-${statusFormat(row, 1)}`" @click="handleDetail(row, 'score')"
                 v-if="[1, 4].includes(statusFormat(row, 1))"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="class-pagination">
      <el-pagination background layout="prev, pager, next, sizes" :pager-count="5"
                     :current-page="query.page" :page-sizes="[20, 30, 40]" :page-size="query.rows"
                     :total="totalRows" @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"></el-pagination>
    </div>
    <async-download-file :isDownloadLoading="isDownloadLoading" :asyncDownloadFun="asyncDownloadFun"
                         @handleClose="handleDownloadClose"></async-download-file>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { downloadAsyncTask } from '@/services/assignTaskApi';
import { queryClassTaskPage, queryClassOperation, downloadStudentOneHomeworkReport, downloadOneClassHomeworkReport } from '@/services/jobManagement';

import AsyncDownloadFile from '@/components/async-download-file';

export default {
  name: 'ClassTable',
  components: {
    AsyncDownloadFile,
  },
  props: {
    activeClassId: {
      type: Number,
      require: true,
    },
    classTaskDetail: {
      type: Object,
      require: true,
    },
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.layout.userInfo,
    }),
  },
  data() {
    return {
      downloadStr: '',
      props: {
        expandTrigger: 'hover',
        emitPath: false,
      },
      options: [
        { label: this.$t('projectV2.original'), value: 'original' },
        { label: this.$t('projectV2.translation'), value: 'translate-translation' },
        { label: this.$t('projectV2.contrast'), value: 'translate-contrast' },
        { label: this.$t('projectV2.xlfreport'), value: 'XLFreport' },
      ],
      isDownloadLoading: false,
      asyncDownloadFun: () => { },
      queryData: {},
      query: {
        filter: {
          classId: 0,
          fileId: 0,
          userName: '',
        },
        rows: 20,
        page: 1,
      },
      totalRows: 0,
      taskList: [],
      classOperation: {},
      allTaskList: [],

      // 切换团队不影响使用的companyCode
      companyCode: JSON.parse(localStorage.getItem("userInfo")).selfCompany.code,
    };
  },
  async mounted() {
    this.queryData = JSON.parse(this.$Base64.decode(this.$route.query.key));
  },
  methods: {
    handleDetail(row, type) {
      sessionStorage.setItem("fileName", row.taskName);
      let param = {
        sourceLang: row.sourceLang,
        targetLang: row.targetLang,
        taskName: row.taskName,
        wordNum: row.sourceWordNum,
        project: 3,
        userId: this.userInfo.id,
        transStatus: 1,
        fileSuffix: this.classTaskDetail.fileUsableSuffix,
        transModel: row.transModel,
        scoreStatus:row.scoreStatus,
        // 老版参数
        fileId: row.fileId,
        projectId: row.projectId,
        isSplit: true,
        type: 'school',
        taskType: row.taskType,
        taskId: row.id,
        'type-school': 'teacher-homework',
        companyCode: row.companyCode,
      };
      // if (type === 'score') {
        // 去评价的判断
        param.toGrade = 1;
      // }
      this.$store.dispatch("editor/updateEvaluationResults", { taskId:row.id });
      this.$router.push({
        path: '/neweditor',
        query: {
          key: this.$Base64.encode(JSON.stringify(param)),
        },
      });
      // window.open(routeData.href, "_self");
    },
    async getClassOperation() {
      let { success, result } = await queryClassOperation(this.query.filter);
      if (success) {
        this.classOperation = result;
      }
    },
    async getClassTaskPage() {
      let { success, list, totalRows } = await queryClassTaskPage(this.query);
      if (success) {
        this.taskList = list;
        this.totalRows = totalRows;
      }
    },
    async getAllClassTaskPage(rows) {
      let { success, list } = await queryClassTaskPage({
        filter: this.query.filter,
        rows,
        page: 1,
      });
      if (success) {
        this.allTaskList = list;
      }
    },
    handleSizeChange(val) {
      this.query.rows = val;
      this.getClassTaskPage();
    },
    handleCurrentChange(val) {
      this.query.page = val;
      this.getClassTaskPage();
    },
    statusFormat(row, type) {
      // finish scoreStatus
      //        1    已评分
      //   1    0    已提交
      //   2    0    进行中
      //   3    0    打回
      //   0    0    未开始
      if (row.scoreStatus === 0) {
        switch (row.finish) {
          case 0:
            return type === 1 ? 0 : this.$t('projectDetailsV2.inProgress');
          case 1:
            return type === 1 ? 1 : this.$t('homeworkManage.submitted');
          case 2:
            return type === 1 ? 2 : this.$t('projectDetailsV2.inProgress');
          case 3:
            return type === 1 ? 3 : this.$t('homeworkManage.refused');
        }
      } else {
        return type === 1 ? 4 : this.$t('homeworkManage.haveScore');
      }
    },
    scoreFormat(row) {
      let status = this.statusFormat(row, 1);
      switch (status) {
        case 0:
          return '--';
        case 1:
          return this.$t('homeworkManage.scoreing');
        case 2:
          return '--';
        case 3:
          return '--';
        case 4:
          return row.manualScore;
      }
    },
    handleNameSearch() {
      if (this.query.filter.userName === '') {
        return;
      }
      this.query.page = 1;
      this.getClassTaskPage();
    },
    searchNameClear() {
      this.query.page = 1;
      this.getClassTaskPage();
    },
    downloadHide() {
      this.downloadStr = '';
    },
    downloadReport(type, row) {
      let id = row.id;
      this.$refs[`popover-${id}`].doClose();
      let downType = null;
      switch (type) {
        case 'original':
          downType = 6;
          break;
        case 'translate-translation':
          downType = 1;
          break;
        case 'translate-contrast':
          downType = 2;
          break;
        case 'XLFreport':
          downType = 10;
          break;
      }
      let params = {
        splitRowsReqVo: {
          end: row.endRow,
          start: row.startRow,
        },
        fileId: this.queryData.id,
        // 相当于项目的翻译任务
        versionType: 1,
        downType,
        taskId: row.id,
        companyCode: this.companyCode,
        transUserId: row.userId
      }
      this.asyncDownloadFun = () => downloadAsyncTask(params);
      this.isDownloadLoading = true;
    },
    handleSingleExport(row) {
      this.asyncDownloadFun = () => downloadStudentOneHomeworkReport({
        projectId: row.projectId,
        userId: row.userId,
        companyCode: this.companyCode,
      });
      this.isDownloadLoading = true;
    },
    handleClassExport() {
      // if (this.homeworkStatusFormat(this.classTaskDetail) !== 3) {
      //   this.$message.closeAll();
      //   this.$message.warning(this.$t('homeworkManage.cannotExport'));
      //   return;
      // }
      if (this.allTaskList.some(item => item.finish === 1)) {
        if (!this.allTaskList.every(item => item.finish === 1)) {
          this.$message.closeAll();
          this.$message.warning(this.$t('homeworkManage.cannotExport'));
        }
        this.asyncDownloadFun = () => downloadOneClassHomeworkReport({
          projectId: this.classTaskDetail.projectId, // 项目id
          companyDepartId: this.activeClassId, // 班级id
          companyCode: this.companyCode,
        });
        this.isDownloadLoading = true;
      } else {
        this.$message.closeAll();
        this.$message.warning(this.$t('homeworkManage.cannotExport'));
      }
    },
    handleDownloadClose() {
      this.asyncDownloadFun = () => { };
      this.isDownloadLoading = false;
    },
    homeworkStatusFormat(row) {
      let total = row.unFinishTaskNumber + row.finishTaskNumber;
      if (total === 0) {
        return 1;
      } else {
        if (row.finishTaskNumber === total) {
          return 3;
        }
        return 2;
      }
    },
  },
  watch: {
    activeClassId: {
      async handler(newVal) {
        this.query.filter.companyCode = this.companyCode;
        this.query.filter.classId = newVal;
        this.query.filter.fileId = this.queryData.id;
        this.getClassOperation();
        await this.getClassTaskPage();
        this.getAllClassTaskPage(this.totalRows);
      },
      deep: true,
    },
  },
}
</script>

<style lang="less" scoped>
.class-table {
  height: 100%;
  line-height: 1.5;
}
.class-header {
  height: 32px;
  display: flex;
  line-height: 32px;
  justify-content: space-between;
  .header-left {
    color: #7a8999;
    display: flex;
    div + div {
      margin-left: 25px;
    }
    .num {
      color: #262b30;
      span {
        color: #0078fc;
      }
    }
    .score {
      color: #ffa43b;
    }
  }
  .header-right {
    display: flex;
    .el-button + .el-input {
      margin-left: 25px;
    }
    /deep/.el-input-group__append {
      background: #0078fc;
      color: #fff;
      .el-button {
        padding: 7px 15px 8px;
      }
    }
  }
}
.table-content {
  margin-top: 15px;
  height: calc(100% - 32px - 32px - 15px - 15px);
  /deep/.el-table__body-wrapper .cell {
    color: #666;
  }
  /deep/.customHeader {
    th {
      background: #f3f7fe;
      color: #566087;
      font-weight: bold;
    }
  }
  .task-status {
    height: 24px;
    line-height: 24px;
    padding: 0 8px;
    display: inline-block;
    border-radius: 2px;
    vertical-align: middle;
  }
  .status-0 {
    // background: rgba(102, 102, 102, 0.08);
    // color: #666;
    color: #FFA43B;
    background-color: #FFF8EF;
  }
  .status-1 {
    background: rgba(0, 120, 252, 0.08);
    color: rgb(0, 120, 252);
  }
  .status-2 {
    background: rgba(255, 164, 59, 0.08);
    color: rgba(255, 164, 59, 1);
  }
  .status-3 {
    color: rgb(255, 105, 105);
    background: rgba(255, 105, 105, 0.08);
  }
  .status-4 {
    background: rgba(35, 195, 67, 0.08);
    color: rgba(35, 195, 67, 1);
  }
  /deep/.operate {
    .cell {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    i {
      display: inline-block;
      width: 17px;
      height: 18px;
      cursor: pointer;
    }
    .el-popover__reference-wrapper {
      display: flex;
    }
    i + i,
    i + span,
    span + i {
      margin-left: 20px;
    }
    .icon-view {
      background: url("~@/assets/imgs/homework/icon-view.png") no-repeat center
        center/17px 18px;
    }
    .icon-view:hover {
      background: url("~@/assets/imgs/homework/icon-view-pre.png") no-repeat
        center center/17px 18px;
    }
    .icon-download {
      background: url("~@/assets/imgs/homework/icon-download.png") no-repeat
        center center/17px 18px;
    }
    .icon-download:hover {
      background: url("~@/assets/imgs/homework/icon-download-pre.png") no-repeat
        center center/17px 18px;
    }
    .icon-report {
      background: url("~@/assets/imgs/homework/icon-report.png") no-repeat
        center center/17px 18px;
    }
    .icon-report:hover {
      background: url("~@/assets/imgs/homework/icon-report-pre.png") no-repeat
        center center/17px 18px;
    }
    .icon-star {
      background: url("~@/assets/imgs/homework/icon-star.png") no-repeat center
        center/17px 18px;
    }
    .icon-star-4 {
      background: url("~@/assets/imgs/homework/icon-star-4.png") no-repeat center
        center/17px 18px;
    }
    .icon-star:hover {
      background: url("~@/assets/imgs/homework/icon-star-pre.png") no-repeat
        center center/17px 18px;
    }
  }
}
.class-pagination {
  height: 32px;
  text-align: center;
  margin-top: 15px;
  /deep/.btn-prev {
    background: none;
    border: 1px solid #c0cccc;
  }
  /deep/.number {
    background: none;
    border: 1px solid #c0cccc;
  }
  /deep/.el-icon-more {
    background: #ffffff;
  }
  /deep/.btn-next {
    background: none;
    border: 1px solid #c0cccc;
  }
  /deep/.el-pagination__sizes {
    margin-right: -10px;
  }
  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    border: 1px solid #0087fc;
    border-radius: 4px;
    background: #ffffff;
    color: #0078fc;
  }
  /deep/.el-pagination.is-background .el-pager li {
    background: #ffffff;
  }
}
</style>

<style lang="less">
.homework-download {
  padding: 0;
  .el-cascader-menu {
    min-width: 130px;
    height: 140px;
  }
  ul {
    li {
      height: 32px;
      .el-icon-check {
        display: none;
      }
      .el-cascader-node__label {
        line-height: 32px;
      }
    }
  }
}
</style>